import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import List from '@mui/material/List';
import Grid from '@mui/material/Grid';

import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import Divider from '@mui/material/Divider';

import { SimTypography } from 'components/SimTypography';
import SimHero from 'components/SimHero';
import SimPolygon from 'components/svg/shapes/SimPolygon';

const pages = [
	{
		id: 'ABATherapy',
		href: '#ANCHOR_Therapy_ABATherapy',
		title: 'ABA Therapy',
		imageIcon: 'https://images.news18.com/ibnlive/uploads/2021/09/childautism-163048404816x9.png'
	},

	{
		id: 'SpeechLanguageTherapy',
		href: '#ANCHOR_Therapy_SpeechTherapy',
		title: 'Speech / Language Therapy',
		imageIcon: 'https://www.monash.edu/__data/assets/image/0008/1906712/banner-functional-behaviour-assessment.jpg'
	},

	{
		id: 'FeedingOccuTherapy',
		href: '#ANCHOR_Therapy_FeedingOccuTherapy',
		title: 'Feeding & Occupational Therapy',
		imageIcon: 'https://childdevelopment.com.au/wp-content/uploads/fine-motor-visual-perception.jpg'
	},
	/*
	{
		id: 'OccupationalTherapy',
		href: '#ANCHOR_Therapy_OccuTherapy',
		title: 'Occupational Therapy',
		imageIcon:
			'https://www.topoccupationaltherapyschool.com/wp-content/uploads/2016/08/Occupational-Therapy-for-Kids.jpg'
	},
	*/
	{
		id: 'CouplesTherapy.',
		href: '#ANCHOR_Therapy_CouplesTherapy',
		title: 'Couples Therapy',
		imageIcon: 'https://www.ryananswers.com/wp-content/uploads/2021/12/couples-counseling-maintenance.jpg'
	}
];

const Page = ({ children }) => {
	const theme = useTheme();

	const [activeLink, setActiveLink] = useState('');
	useEffect(() => {
		setActiveLink(window && window.location ? window.location.pathname : '');
	}, []);

	const [selectedIndex, setSelectedIndex] = React.useState(1);
	const handleListItemClick = (event, index) => {
		setSelectedIndex(index);
	};

	return (
		<Box bgcolor={theme.palette.background.default}>
			{/*TOP HEADER*/}

			<Box
				position={'relative'}
				sx={{
					backgroundColor: theme.palette.primary.main
				}}>
				<Box paddingLeft={{ xs: 2, sm: 4, lg: 16 }} paddingRight={{ xs: 2, sm: 4, lg: 8 }} paddingBottom={4}>
					<SimHero
						topTitle='Early intervention is'
						bottomTitle='the best for'
						content='Developmental delays can be intervened as early as 18-months.  Early intervention leads to best developmental outcomes as brain’s ability to change in response to experiences is highest in the first 5 years.'
						firstBtnText='ABA Therapy'
						secondBtnText='Speech Language Therapy'
						thirdBtnText='Feeding / Occupational Therapy'
					/>
				</Box>

				<Box top={'-50px'}>
					<SimPolygon />
				</Box>
			</Box>

			{/* SIDEBAR */}
			<Box
				paddingTop={'0 !important'}
				marginTop={0}
				bgcolor={theme.palette.background.page}
				/* paddingRight='1vw' */
				boxShadow={2}>
				<Grid container spacing={0}>
					<Grid item xs={12} md={2.1}>
						<Box
							sx={{
								top: { xs: '10vh', md: '0vh' },
								height: { xs: 'auto', md: '847vh' },
								position: 'relative',
								display: { xs: 'none', sm: 'none', md: 'block' }
							}}>
							<Box
								marginTop={3}
								sx={{
									top: { xs: '5vh', md: '12vh' },
									height: { xs: 'auto', md: 'auto' },
									position: { xs: 'fixed', md: 'sticky' },

									display: { xs: 'none', sm: 'none', md: 'block' },

									bgcolor: { xs: theme.palette.background.page, md: 'none' },
									zIndex: { xs: 5, md: 0 }
								}}>
								<Card marginTop={6}>
									<Box sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.default' }}>
										<List component='nav' aria-label='main mailbox folders'>
											{pages.map((item, i) => (
												<Box>
													<ListItemButton
														selected={selectedIndex === 0}
														onClick={event => handleListItemClick(event, 0)}
														key={item.id}
														alignItems='flex-start'
														href={item.href}>
														<ListItemAvatar>
															<Avatar alt='Remy Sharp' src={item.imageIcon} />
														</ListItemAvatar>

														<ListItemText>
															<SimTypography
																variant='subtitle2'
																color={activeLink === item.href ? 'white' : 'black'}>
																{item.title}
															</SimTypography>
														</ListItemText>
													</ListItemButton>
													{pages.length === i + 1 ? null : (
														<Divider variant='inset' component='li' />
													)}
												</Box>
											))}
										</List>
									</Box>
								</Card>
							</Box>
						</Box>
					</Grid>
					<Grid item xs={12} md={9.9}>
						{/* <Card sx={{ boxShadow: 2, padding: 0 }}>{children}</Card> */}
						{children}
					</Grid>
				</Grid>
			</Box>
		</Box>
	);
};

Page.propTypes = {
	children: PropTypes.node
};

export default Page;
